import Vue from 'vue';

export default {
	get() {
		return new Promise((resolve, reject) => {
			Vue.http.post(process.env.GET_DASHBOARD_OVERVIEW_URL, { })
			.then((response) => {
				resolve(response.body.objekte);
			})
			.catch((response) => {
				reject(response);
			});
		});
	},

	getCMSStructure() {
		return new Promise((resolve, reject) => {
			Vue.http.post(process.env.GET_CMS_STRUCTURE_URL)
			.then((response) => {
				resolve(response.body);
			})
			.catch((response) => {
				reject(response);
			});
		});
	},

	copyObject(id, props = {}) {
		return new Promise((resolve, reject) => {
			Vue.http.post(process.env.OBJECT_COPY_URL, { PKM_Objekt: id, ...props })
			.then((response) => {
				response.body.sourceId = id;
				resolve(response.body);
			})
			.catch((response) => {
				reject(response);
			});
		});
	},

	batchCopyObject(ids) {
		const promisifiedCopyObjectRequests =
			ids.map(id => this.copyObject(id));
		return Promise.all(promisifiedCopyObjectRequests);
	},

	copyObjectEmpty(id) {
		return this.copyObject(id, { modus: 'leer_kopieren' });
	},

	batchCopyObjectEmpty(ids) {
		const promisifiedCopyObjectRequests =
			ids.map(id => this.copyObjectEmpty(id));
		return Promise.all(promisifiedCopyObjectRequests);
	},

	createNewObject(specificationId, genusId, objectname) {
		return new Promise((resolve, reject) => {
			Vue.http.post(process.env.CREATE_NEW_OBJECT_URL, {
				S_de_Objekt: objectname,
				FKM_Spezifikation: specificationId,
				FKM_Gattung: genusId,
			})
			.then((response) => {
				resolve(response.body);
			})
			.catch((response) => {
				reject(response);
			});
		});
	},

	getUserSpecifications() {
		return new Promise((resolve, reject) => {
			Vue.http.post(process.env.GET_USER_SPECIFICATIONS_URL)
			.then((response) => {
				resolve(response.body.objekte);
			})
			.catch((response) => {
				reject(response);
			});
		});
	},
};



// WEBPACK FOOTER //
// ./src/api/dashboard.js